export default __webpack_public_path__ + "static/media/Terms.ac6f6dc1.pdf";